import { Dialog, DialogContent, Paper,DialogTitle } from "@mui/material";
import { Box } from "@mui/system";

import Draggable from "react-draggable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

export function PopupModal({ open, handleClose, modalContent,title,modalHeight,modalWidth }) {
  // const fileType = href ? href.includes("pdf") : false;

  function PaperComponent(props) {
    return (
      <Draggable handle="#modalBox">
        <Paper {...props} />
      </Draggable>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Prevent closing on backdrop click or Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }

        handleClose();
      }}
      // aria-labelledby="modalBox"
      // aria-describedby="modal-modal-description"
      // PaperComponent={PaperComponent}
      style={{ cursor: "move" }}
    >
      {" "}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px",
        }}
      >
        <h3>{title}</h3>
        <button
          style={{
            width: "20px",
            height: "20px",
            border: "none",
            // padding: "12px",
            borderRadius: "50%",
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
            // marginBottom: "5px",
            flexDirection: "row",
            // float: "right",
            // margin: "2px",
          }}
          onClick={handleClose}
        >
          X
        </button>
      </div>
     
      <DialogContent id="modalBox">
        <Box
          display="flex"
          justifyContent="center"
          // alignItems="center"
          mb={2}
          sx={{ height: `${modalHeight || '300px'}`, width: `${modalWidth || '500px'}` }}
        >
          {" "}
          {modalContent}
        </Box>
        {/* <Box sx={{ height: "300px", width: "500px", marginTop: "10px" }}>
          {/* {fileType ? (
            <Box sx={style}>
              <iframe src={href} title={name} height={400} width={500} />
            </Box>
          ) : (
            <Box sx={style}>
              <img
                src={href}
                alt={name}
                style={{ width: "500px", height: "400px" }}
              />
            </Box>
          )} 
        </Box> */}
      </DialogContent>
    </Dialog>
  );
}
